module.exports = __webpack_public_path__ + "img/app-store-badge.f6446b01.png";